<template>
  <v-card :disabled="loading" :loading="loading" outlined tile>
    <v-card-text class="pa-1">
      <v-form ref="form" v-if="form">
        <v-simple-table>
          <tbody>
          <tr>
            <th>Customer</th>
            <td>
              <v-row>
                <v-autocomplete
                    v-model="form.customer_id"
                    :items="customers"
                    item-text="name"
                    item-value="customer_id"
                    :disabled="!disableCustomerField"
                    @focus="loadRestOfNames"
                    dense
                >
                </v-autocomplete>
                <v-checkbox label="Edit Customer" v-model="disableCustomerField" dense></v-checkbox>
              </v-row>
            </td>
          </tr>
          <tr>
            <th>Required Tests</th>
            <td>
              <v-btn-toggle v-model="selectedTestTypes" multiple dense>
                <v-btn
                    :active-class="disabledTestUpdate(type.uuid) ? 'yellow darken-1' : 'error white--text'"
                    :class="{'disable-events': disabledTestUpdate(type.uuid)}"
                    v-for="type in sampleTestTypes"
                    :key="type.uuid"
                    :value="type.uuid"
                    small
                >
                  {{ type.name }}
                </v-btn>
              </v-btn-toggle>
            </td>
          </tr>
          <tr>
            <th>Name associated with sample</th>
            <td>
              <v-autocomplete
                  v-model="form.customer_name_id"
                  :items="brands"
                  item-text="name"
                  item-value="id"
                  clearable
                  dense
                  @focus="loadRestOfBrands"
              >
              </v-autocomplete>
            </td>
          </tr>
          <tr>
            <th>Manifest ID</th>
            <td>
              <v-text-field
                  v-model="form.manifest_id"
                  dense
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <th>Sample Name</th>
            <td>
              <v-text-field v-model="form.name"
              dense></v-text-field>
            </td>
          </tr>
          <tr>
            <th>Sample Product Type</th>
            <td>
              <v-autocomplete
                  v-model="form.sample_cert_type_uuid"
                  :items="sampleTypes"
                  item-text="name"
                  item-value="uuid"
                  dense
              >
                <template v-slot:prepend>
                  <v-chip :color="chipColor"
                          small></v-chip>
                </template>
              </v-autocomplete>
            </td>
          </tr>
          <tr>
            <th>Legal Type</th>
            <td>
              <v-autocomplete v-model="form.legal_type" :items="legalTypes" dense></v-autocomplete>
            </td>
          </tr>
          <tr>
            <th>Qa</th>
            <td>
              <v-text-field
                  v-model="form.qa"
                  dense
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <th>Lot</th>
            <td>
              <v-text-field
                  v-model="form.lot"
                  dense
              >
              </v-text-field>
            </td>
          </tr>
<!--          <tr>-->
<!--            <th>Harvest Date</th>-->
<!--            <td>-->
<!--              <v-text-field-->
<!--                  v-model="form.harvest_date"-->
<!--                  dense-->
<!--              >-->
<!--              </v-text-field>-->
<!--            </td>-->
<!--          </tr>-->
          <tr>
            <th>Unit Weight</th>
            <td>
              <v-text-field
                  v-model="form.serving_weight"
                  dense
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <th>QA vs RND</th>
            <td>
              <v-radio-group v-model="form.is_rnd" row dense>
                <v-radio
                    label="QA"
                    :value="false"
                >
                </v-radio>
                <v-radio
                    label="RND"
                    :value="true"
                >
                </v-radio>
              </v-radio-group>
            </td>
          </tr>
          <tr v-if="form.meta_data">
            <th>License</th>
            <td>
              <v-select v-model="form.meta_data.license" label="" :items="licenses" @focus="loadLicenses()" item-text="license" item-value="license" clearable></v-select>
            </td>
          </tr>
          <tr v-if="form.meta_data">
            <th>Package Weight</th>
            <td>
              <v-text-field v-model="form.meta_data.package_weight" label=""></v-text-field>
            </td>
          </tr>
          <tr v-if="form.meta_data">
            <th>Collection Date</th>
            <td>
              <v-text-field v-model="form.meta_data.collection_date" label=""></v-text-field>
            </td>
          </tr>
          <tr v-if="form.meta_data">
            <th>Strain Name</th>
            <td>
              <v-text-field v-model="form.meta_data.strain_name" label=""></v-text-field>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-form>
    </v-card-text>
    <v-card-actions class="pt-1">
      <v-btn @click="save" color="success" block>submit</v-btn>
<!--      <Confirm title="You are updating a released sample do you want to re-release it?" has_no confirm_text="Yes" message='Selecting "NO" will update the sample without re-release.'>-->
<!--        <template v-slot:activator="{on}">-->
<!--          <v-btn v-on="on" color="success" block>submit</v-btn>-->
<!--        </template>-->
<!--      </Confirm>-->
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "SampleEditForm",
  components: {},
  props: {
    sample: {
      required: true,
    }
  },
  data: () => ({
    show: false,
    loading: false,
    disableCustomerField: false,
    form: {
      id: null,
      uuid: null,
      customer_id: null,
      customer_name_id: null,
      manifest_id: null,
      name: null,
      sample_cert_type_uuid: null,
      qa: null,
      lot: null,
      serving_weight: null,
      is_rnd: null,
      harvest_date: null,
      sample_tests: [],
      meta_data: {
        license: null,
        package_weight: null,
        strain_name: null,
      }
    },
    removeTests: [],
    customers: [],
    brands: [],
    licenses: [],
    legalTypes: [
      "NON-502:NON-502",
      "PropagationMaterial:Clones",
      "PropagationMaterial:Plant",
      "PropagationMaterial:Seed",
      "HarvestedMaterial:FlowerLot",
      "HarvestedMaterial:FlowerUnlotted",
      "HarvestedMaterial:OtherMaterialLot",
      "HarvestedMaterial:OtherMaterialUnlotted",
      "HarvestedMaterial:WetFlower",
      "IntermediateProduct:CannabisMix",
      "IntermediateProduct:CBD",
      "IntermediateProduct:FoodGradeSolventConcentrate",
      "IntermediateProduct:InfusedCookingMedium",
      "EndProduct:CannabisMixInfused",
      "EndProduct:CannabisMixPackaged",
      "EndProduct:Capsule",
      "EndProduct:CO2Concentrate",
      "EndProduct:ConcentrateForInhalation",
      "EndProduct:EthanolConcentrate",
      "EndProduct:HydrocarbonConcentrate",
      "EndProduct:LiquidEdible",
      "EndProduct:Non-SolventBasedConcentrate",
      "EndProduct:SampleJar",
      "EndProduct:SolidEdible",
      "EndProduct:Suppository",
      "EndProduct:Tincture",
      "EndProduct:TopicalOintment",
      "EndProduct:Transdermal",
      "EndProduct:UsableCannabis"

    ],
  }),
  computed: {
    sampleTypes() {
      return this.$store.$db().model('sampleCertTypes').all();
    },
    sampleTestTypes() {
      let types = this.$store.$db().model('sampleTestTypes').all();
      let filtered = this.$store.state.filtered_test_types || [];
      if (filtered.length === 0) return types;
      return types.filter(type => {
        if (!filtered.includes(type.uuid)) return true;
        let hasInForm = this.form && this.form.sample_tests && this.form.sample_tests.some(test => (test.sample_test_type_uuid === type.uuid || (test.test_type && test.test_type.uuid === type.uuid)) && test.active !== false);
        let hasInSample = this.sample && this.sample.sample_tests && this.sample.sample_tests.some(test => (test.sample_test_type_uuid === type.uuid || (test.test_type && test.test_type.uuid === type.uuid)) && test.active !== false);
        return hasInForm || hasInSample;
      });
    },
    unit() {
      return this.$store.$db().model('units').query().where('name', 'g').first();
    },
    chipColor(){
      if(!this.form.sample_cert_type_uuid) return '';
      return this.$store.$db().model('sampleCertTypes').find(this.form.sample_cert_type_uuid).color
    },
    selectedTestTypes: {
      get() {
        if (!this.form) return [];
        return this.form.sample_tests.filter(test => test.active).map(test => {
          return test.test_type.uuid
        })
      },
      set(v) {
        if (this.selectedTestTypes.length > v.length) {
          let findTestType = this.selectedTestTypes.find(type => !v.some(test => test === type))
          if (findTestType) {
            for (let i in this.form.sample_tests) {
              let test = this.form.sample_tests[i];
              if (test.sample_test_type_uuid === findTestType) {
                if (test.mass.value_1 > 0 || test.sample_test_analyte_count > 0) {
                  this.$store.dispatch('showError', "This test has a weight or analyte already applied and cannot be removed. Test must be deactivated inside ConAn 3.")
                } else {
                  if (test.uuid) {
                    this.removeTests.push(test);
                  }
                  this.form.sample_tests.splice(i, 1);
                }
              }
            }
          }
          console.log('remove');
        } else if (this.selectedTestTypes.length < v.length) {
          let findTestType = v.find(type => !this.selectedTestTypes.some(test => test === type))
          if (findTestType) {
            let findRemoved = this.removeTests.find(test => test.sample_test_type_uuid === findTestType);
            if (findRemoved) {
              let index = this.removeTests.findIndex(test => test.sample_test_type_uuid === findTestType)
              this.form.sample_tests.push(findRemoved);
              this.removeTests.splice(index, 1);
            } else {
              let testTypeObject = this.$store.$db().model('sampleTestTypes').find(findTestType)
              this.form.sample_tests.push({
                uuid: null,
                sample_uuid: this.form.uuid,
                sample_test_type_uuid: findTestType,
                test_type: testTypeObject,
                display_index: 0,
                mass: 0,
                unit_uuid: this.unit.uuid,
                retest: false,
                passed: false,
                complete: false,
                active: true,
                created_by: this.$store.getters.id,
                updated_by: this.$store.getters.id,
              })
            }
          }
        } else {
          console.log('even')
        }
      }
    },
  },
  mounted() {
      this.setSample();
      setTimeout(() => {
        this.customers = this.$store.$db().model('names').query().where('customer_id', this.sample.customer_id).where('name_type_id', 1).get();
      }, 1500)
  },
  watch: {
    show(v) {
      this.setSample()
    },
  },
  methods: {
    loadRestOfNames(){
      this.customers = this.$store.$db().model('names').query().where('name_type_id', 1).get();
    },
    loadRestOfBrands(){
      this.brands = this.$store.$db().model('names').query().where('customer_id', this.sample.customer_id).get();
    },
    async loadLicenses(){
      const licenses = await this.$store.$db().model('licenses').api().fetch({
        where: [
          {key: 'customer_id', value: this.sample.customer_id}
        ]
      }, "",
      null,
      false,
      false);
      this.licenses = licenses.response.data;
    },
    setSample() {
      this.form = null;
      this.removeTests = [];
      // this.form = {...this.sample, sample_tests: [...this.sample.sample_tests]};
      if(this.sample.meta_data && this.sample.meta_data.license){
        this.licenses = [{license: this.sample.meta_data.license}]
      }
      const meta_data = this.sample.meta_data ? this.sample.meta_data : {};
      if(!meta_data.package_weight) meta_data.package_weight = null;
      if(!meta_data.license) meta_data.license = null;
      if(!meta_data.collection_date) meta_data.collection_date = null;
      if(!meta_data.strain_name) meta_data.strain_name = null;
      this.form = {
        id: this.sample.id,
        uuid: this.sample.uuid,
        customer_id: this.sample.customer_id,
        customer_name_id: this.sample.customer_name_id,
        manifest_id: this.sample.manifest_id,
        name: this.sample.name,
        legal_type: this.sample.legal_type,
        sample_cert_type_uuid: this.sample.sample_cert_type_uuid,
        qa: this.sample.qa,
        lot: this.sample.lot,
        serving_weight: this.sample.serving_weight,
        is_rnd: this.sample.is_rnd,
        harvest_date: this.sample.harvest_date,
        sample_tests: [...this.sample.sample_tests],
        meta_data: meta_data,
      };
      console.log(this.form)
    },
    disabledTestUpdate(type) {
      return this.sample.sample_tests.some(test => test.sample_test_type_uuid === type && (test.mass.value_1 > 0 || test.sample_test_analyte_count > 0))
    },
    close() {
      this.setSample();
      this.show = false;
    },
    async save() {
      this.loading = true;
      const setQaApprove = this.sample.qa_approved
          ? !this.form.sample_tests.filter(test => !test.retest).some(test => !test.uuid)
          : this.sample.qa_approved
      await this.$store.$db().model('samples').api().save({
        ...this.form,
        sample_test: null,
        qa_approved: setQaApprove,
        updated_by: this.$store.getters.id,
      })
      await this.$store.$db().model('sampleTests').api().save({
        collection: this.form.sample_tests
      })
      if (this.removeTests.length > 0) {
        for (let i in this.removeTests) {
          await this.$store.$db().model('sampleTests').api().destroy(this.removeTests[i].uuid, 'Deleted required test: ' + this.removeTests[i].test_type.name);
        }
      }
      this.$store.dispatch('showSuccess', "Sample Updated")
      this.setSample();
      await this.$store.$db().model('samples').api().fetch({
        where: [
          {key: 'uuid', value: this.sample.uuid}
        ],
      })
      this.loading = false
    }
  }
}
</script>

<style scoped>
.disable-events {
  pointer-events: none;
}
</style>
